"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = exports.initialFilterOptions = exports.initialOrderByOptions = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/order/list");
exports.initialOrderByOptions = {
    orderBy: 'createdAt',
    order: 'desc'
};
exports.initialFilterOptions = {};
exports.initialState = {
    status: 'STANDBY',
    deleteStatus: 'STANDBY',
    copyStatus: 'STANDBY',
    error: '',
    list: [],
    searchString: '',
    limit: 350,
    itemsPerPage: [350, 700, 1400],
    offset: 0,
    orderByOptions: Object.assign({}, exports.initialOrderByOptions),
    filterOptions: Object.assign({}, exports.initialFilterOptions),
    filter: 'only-my',
    selected: []
};
//#endregion
//#region LENS
const statusLens = monocle.Lens.fromProp('status');
const deleteStatusLens = monocle.Lens.fromProp('deleteStatus');
const copyStatusLens = monocle.Lens.fromProp('copyStatus');
const listLens = monocle.Lens.fromProp('list');
const errorLens = monocle.Lens.fromProp('error');
const searchStringLens = monocle.Lens.fromProp('searchString');
const limitLens = monocle.Lens.fromProp('limit');
const offsetLens = monocle.Lens.fromProp('offset');
const orderByOptionsLens = monocle.Lens.fromProp('orderByOptions');
const filterOptionsLens = monocle.Lens.fromProp('filterOptions');
const filterLens = monocle.Lens.fromProp('filter');
const selectedLens = monocle.Lens.fromProp('selected');
const methods = {};
exports.methods = methods;
methods[Actions.FETCH_REQUEST] = (state) => statusLens.set('FETCHING')(state);
methods[Actions.FETCH_SUCCESS] = (state, action) => fp.function.compose(statusLens.set('FETCHED'), filterLens.set(action.payload.filter), listLens.set(action.payload.list))(state);
methods[Actions.FETCH_FAILED] = (state, action) => fp.function.compose(statusLens.set('FAILED'), errorLens.set(action.payload.error))(state);
methods[Actions.SET_SEARCH_STRING] = (state, action) => searchStringLens.set(action.payload.searchString)(state);
methods[Actions.SET_LIMIT] = (state, action) => limitLens.set(action.payload.limit)(state);
methods[Actions.SET_OFFSET] = (state, action) => offsetLens.set(action.payload.offset)(state);
methods[Actions.SET_ORDER_BY_OPTIONS] = (state, action) => orderByOptionsLens.set(action.payload)(state);
methods[Actions.SET_FILTER_OPTIONS] = (state, action) => filterOptionsLens.modify((filters) => {
    const copy = Object.assign({}, filters);
    if (action.payload.value) {
        copy[action.payload.filter] = action.payload.value;
    }
    else {
        delete copy[action.payload.filter];
    }
    return copy;
})(state);
methods[Actions.SELECT_ORDER] = (state, action) => selectedLens.modify((orders) => {
    const copy = [...orders];
    const { order } = action.payload;
    const pos = copy.findIndex((x) => x.id === order.id);
    if (pos > -1) {
        copy.splice(pos, 1);
    }
    else {
        copy.push(order);
    }
    return copy;
})(state);
methods[Actions.DELETE_ORDER] = (state, action) => deleteStatusLens.set('DELETING')(state);
methods[Actions.DELETE_ORDER_SUCCESS] = (state, action) => fp.function.compose(selectedLens.set([]), listLens.modify((orders) => orders.filter((x) => action.payload.findIndex((z) => z.id === x.id) === -1)), deleteStatusLens.set('DELETED'))(state);
methods[Actions.DELETE_ORDER_FAILURE] = (state, action) => deleteStatusLens.set('FAILED')(state);
methods[Actions.CLEAR] = (state) => (Object.assign({}, exports.initialState));
methods[Actions.COPY_ORDER] = (state) => copyStatusLens.set('COPYING')(state);
methods[Actions.COPY_ORDER_FAILURE] = (state) => copyStatusLens.set('FAILED')(state);
methods[Actions.COPY_ORDER_SUCCESS] = (state) => copyStatusLens.set('COPIED')(state);
//# sourceMappingURL=list.js.map